<template>
  <div class="area-chart-container">
    <vue-apex-charts
      id="monitoring-chart"
      height="250"
      class="response-chart"
      :options="chartOptions"
      type="area"
      :series="resTimeSeriesComputed"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'HealthcheckLogChart',
  components: {
    VueApexCharts,
  },
  computed: {
    healthcheckStats() {
      return this.$store.state.healthcheckLogs.healthcheckStats
    },
    chartOptions() {
      return {
        chart: {
          id: 'res-time-area',
          group: 'healthchecks',
          zoom: {
            enabled: false,
          },
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        colors: ['#419EF7'],
        dataLabels: {
          enabled: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
        },
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            minWidth: '10px',
            formatter(val) {
              return `${val.toFixed(0)}`
            },
          },
        },
        xaxis: {
          type: 'category',
          tickAmount: 6,
          labels: {
            minWidth: '10px',
            style: {
              fontSize: '12px',
            },
            offsetX: 5,
            rotate: 0,
          },
          categories: this.returnLabels(),
          tooltip: {
            enabled: false,
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              if (val === 0.1) {
                return 'timeout'
              }
              if (val === 0) {
                return 'no data'
              }
              return `${val.toFixed(0)}ms`
            },
          },
        },
        responsive: [
          {
            breakpoint: 769,
            options: {
              xaxis: {
                tickAmount: 3,
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              xaxis: {
                tickAmount: 1,
              },
            },
          },
        ],
      }
    },
    resTimeSeriesComputed() {
      return this.responseTimeSeries()
    },
  },
  methods: {
    responseTimeSeries() {
      const series = [
        {
          name: 'Response time',
          data: this.healthcheckStats.length > 0 ? Array(60).fill(0) : [],
        },
      ]

      this.healthcheckStats.forEach((e, index) => {
        series[0].data[index] = e.responseTime
      })

      series[0].data.reverse()
      return series
    },
    returnLabels() {
      const series = this.healthcheckStats.length > 0 ? Array(60).fill('No Data') : []
      this.healthcheckStats.forEach((e, index) => {
        series[index] = `${this.timeSince(e.executedAt)} ago`
      })

      return series.reverse()
    },
  },
}
</script>
